import { withStyles } from '@material-ui/core/styles';

export const quickshopStyles = theme => ({
  copyright: {
    height: '100px',
  },
  topText: {
    marginTop: '1em',
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing.unit,
    top: theme.spacing.unit,
    color: theme.palette.grey[500],
  },
  centered: {
    textAlign: 'center',
  }
});

export const withQuickshopStyles = withStyles(quickshopStyles)